import
{
    IonButton,
    IonButtons,
    IonToolbar
} from "@ionic/react";

import React, {
    FC,
    PropsWithChildren,
    ReactNode
} from "react";

import
{
    NetworkStatus
} from "../../NetworkStatus";

import Icon from "@ews/react-icons";

export type Props = {
    buttons?: ReactNode[];
    filter?: boolean;
    onFilterOpen?: (state: boolean) => void;
    isFilterOpen?: boolean;
    activeFilter?: boolean;
};

const Main: FC<PropsWithChildren & Props> = ({
    children,
    buttons = [],
    filter = false,
    onFilterOpen,
    isFilterOpen = false,
    activeFilter = false
}) =>
{
    return (<>
        <IonToolbar color={'light'}>
            <IonButtons slot="start">
                {filter ?
                    <IonButton
                        size="small"
                        color={activeFilter ? 'dark' : 'primary'}
                        shape="round"
                        fill="solid"
                        onClick={() =>
                        {
                            if (onFilterOpen) onFilterOpen(!isFilterOpen);
                        }}
                    >
                        <Icon
                            width={18}
                            height={18}
                            icon={activeFilter ? "filter_active" : "filter_empty"}
                            style={activeFilter ? { stroke: "white" } : {}}
                        />
                    </IonButton>

                    : null}
                {buttons.map((button, index) => <React.Fragment key={index}>{button}</React.Fragment>)}
            </IonButtons>

            <IonButtons style={{ gap: "15px", padding: "5px" }} slot="end">
                {children}
                <NetworkStatus />
            </IonButtons>
        </IonToolbar >
    </>);
};

export default Main;